import { BaseReservation } from "@r6digital/rapidstor-types/types/Reservation";
import { RapidStorEvent } from "@r6digital/rapidstor-types/types/Events/Event";
import {
  ReservationEvent,
  ReservationEventPayloadStandard,
  ReservationViaMoveInEvent,
} from "@r6digital/rapidstor-types/types/Events/Reservation";
import Location from "./entities/Location";

/** Dispatches a `rapidstor` event and a type-specific `rapidstor.<type>` event. */
export const dispatchEvent = (event: RapidStorEvent) => {
  document.dispatchEvent(new CustomEvent<RapidStorEvent>("rapidstor", { detail: event }));
  document.dispatchEvent(
    new CustomEvent<RapidStorEvent>(`rapidstor.${event.type}`, { detail: event })
  );
};

/** Builds the conversion context RapidStor sends with its own reservation events. */
export const reservationEventPayload = (
  reservation: BaseReservation,
  location: Location,
  dealTitle: string | null
): ReservationEventPayloadStandard => {
  const { unitType } = reservation;
  const rate = reservation.rates.rate;

  return {
    deal_name: dealTitle,
    quoted_rate_monthly: rate,
    quoted_rate_weekly: (rate * 12) / 52,
    reservation,
    site_info: {
      location_code: location.locationCode,
      site_token: location.token,
    },
    size: unitType.area,
    tenant: {
      tenantId: reservation.tenantId,
      firstName: reservation.firstName,
      lastName: reservation.lastName,
      email: reservation.email,
      phone: reservation.phone,
    },
    transaction_id: reservation.token,
    unit_id: unitType.unitToUse?.UnitID ?? reservation.UnitID,
    unit_length: unitType.length,
    unit_name: reservation.sUnitName,
    unit_rate: rate,
    unit_width: unitType.width,
    value: rate,
  };
};

export const reservationEvent = (payload: ReservationEventPayloadStandard) => {
  const event: ReservationEvent = { type: "reservation", context: payload };
  dispatchEvent(event);
};

export const reservationViaMoveInEvent = (payload: ReservationEventPayloadStandard) => {
  const event: ReservationViaMoveInEvent = {
    type: "reservation-via-move-in",
    context: payload,
  };
  dispatchEvent(event);
};
